import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import { fetcherPost } from "../../../../../services/fetcher";
import CustomButton from "../../../../components/CustomButton";
import ModalLayout from "../../../../components/ModalLayout";

interface Props {
  id: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
  onOk: () => void;
}

export default function CancleOrderModal(props: Props) {
  const { open, setOpen, onOk, id } = props;

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const {
    // trigger: setShipStatusTrigger,
    isMutating: setShipStatusTriggerMutating,
  } = useSWRMutation(
    [`/Nobat/SetShipStatus`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        setOpen(false);
      },
    }
  );

  const { trigger: cancleOrder, isMutating: isCancleOrderMutating } =
    useSWRMutation(
      [`/PreOrder/Delete`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          if (data.errorCode) {
            setOpen(false);
          } else {
            onOk();
            navigate("../manage-orders");
          }
        },
      }
    );

  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "32px",
        }}
      >
        <Typography textAlign={"center"}>
          آیا از لغو این سفارش مطمئن هستید؟
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <CustomButton
            loading={isCancleOrderMutating}
            onClick={() => {
              cancleOrder({ id });
            }}
            flex={1}
            title="بله"
            bgColor="success.main"
            justifyContent="center"
            fSize="16px"
            px="6px"
            py="10px"
            borderRadius="6px"
            // icon2={<DownloadLikeLogin color={"#fff"} />}
          />
          <CustomButton
            onClick={() => setOpen(false)}
            flex={1}
            title="خیر"
            borderColor="error.main"
            bgColor="error.light"
            justifyContent="center"
            fSize="16px"
            textColor="error.main"
            px="6px"
            py="10px"
            borderRadius="6px"
            // icon2={<DownloadLikeLogin color={"#fff"} />}
          />
        </Box>
      </Box>
    </ModalLayout>
  );
}
